import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/out/order/after/sales/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/out/order/after/sales/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/out/order/after/sales/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/out/order/after/sales/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/out/order/after/sales/update', params,options)

//售后单处理
export const handle = (params, options) =>
request.post('/api/v4ward/out/order/after/sales/handle', params,options)

//售后字典接口
export const getDictData = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));
